import { EntityUnionType } from 'common/types/entities/EntityInterface'
import ServerPageInterface from 'src/shared/types/server-page-interface'
import { ParentIdEntityInterface } from 'src/shared/schemas/parent-id-schema'

/* NOTE: fix parentId if the parentId is equal a id of a lost entity
 *
 * ------CASE 1-------
 * entities: {
 *  bodyEntity: {
 *    childIds: [entity1]
 *  },
 *  entity1: {
 *    parentId: bodyEntity,
 *    childIds: []
 *  },
 *  entity2: {
 *    parentId: entity4,
 *    childIds: []
 *  },
 *  entity3: {
 *    parentId: bodyEntity,
 *    childIds: [entity2]
 *  }
 * }
 * entity2 parentId equals entity4, which doesn't exist in entities, and entity3 childIds has entity2,
 * therefore we have to change entity2 parentId to entity3
 * -------------------
 *
 * ------CASE 2-------
 * entities: {
 *  bodyEntity: {
 *    childIds: [entity1]
 *  },
 *  entity1: {
 *    parentId: bodyEntity,
 *    childIds: []
 *  },
 *  entity2: {
 *    parentId: entity1,
 *    childIds: []
 *  },
 *  entity3: {
 *    parentId: bodyEntity,
 *    childIds: [entity2]
 *  }
 * }
 * entity2 parentId equals entity1, which childIds doesn't have entity2, and entity3 childIds has entity2,
 * therefore we have to change entity2 parentId=entity3
 * -------------------
 */
export default function fixParentIdCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  let needChangeContent = false
  const originalEntities = page.content.entities
  const originalEntitiesValues = Object.values(originalEntities)
  const originalEntitiesKeys = new Set(Object.keys(originalEntities))

  // biome-ignore lint/complexity/noForEach: <explanation>
  originalEntitiesValues.forEach(entity => {
    if ('parentId' in entity && entity.parentId) {
      const isParentIdLost = !originalEntitiesKeys.has(entity.parentId)
      const parentEntity = originalEntities[entity.parentId]
      if (
        // there is no this entity in the entities (CASE 1)
        isParentIdLost ||
        // entity parentId doesn't have entity in childIds (CASE 2)
        !(
          'childIds' in parentEntity &&
          parentEntity.childIds?.includes(entity.id)
        )
      ) {
        originalEntitiesValues.some(entity2 => {
          if ('childIds' in entity2 && entity2.childIds) {
            const isEntity2Parent = entity2.childIds.includes(entity.id)
            if (isEntity2Parent) {
              needChangeContent = true
              ;(
                originalEntities[entity.id] as EntityUnionType &
                  ParentIdEntityInterface
              ).parentId = entity2.id
              return true
            }
          }
        })
      }
    }
  })

  return [page, needChangeContent]
}
